import { apiRequest, ResultAPI } from 'app/requests/apiRequest';
import { buildParams } from 'app/utils/pagination';
import { Message } from 'types/chat';

export const getComments = async (roomId: string, page: number) => {
  const paramsUrl = buildParams({ page });
  const result = await apiRequest(`/api/comments/${roomId}${paramsUrl}`, 'get') as ResultAPI;

  return result.data;
}

export const deleteComment = async (commentId: number | null) => {
  await apiRequest(`/api/comments/${commentId}`, 'delete');
}

export const toggleLikeComment = async (commentId: number) => {
  const comment = await apiRequest(`/api/comments/${commentId}/toggle-like`, 'post');

  return comment as Message;
}

export const updateComment = async (commentId: number | null, content: string) => {
  const comment = await apiRequest(`/api/comments/${commentId}`, 'put', { content });

  return comment as Message;
}

export const storeComment = async (message: Message, roomId: string) => {
  const baseUrl = window.location.origin + window.location.pathname;
  const result = await apiRequest(`/api/comments`, 'post', {
    ...message,
    room_id: roomId,
    link: baseUrl,
  });

  return result as Message;
}
